<template>
  <div class="loading-card">
    <Icon
      name="line-md:loading-twotone-loop"
      v-bind="$attrs"
      class="loading-card__icon"
    />
  </div>
</template>
